import { DEDUCTION_SCHEDULES, ADD_EDIT_DEDUCTION_SETTINGS, DELETE_SCHEDULE } from '../../types';

const DeductionSchedules = (state = [], action) => {
    switch (action.type) {
        case DEDUCTION_SCHEDULES:
            state = action.payload;
            return state;
        case ADD_EDIT_DEDUCTION_SETTINGS:
            let found = state.find(s => s._id === action.payload._id);
            if (found) found = { ...found, ...action.payload }
            else state = [...state, ...action.payload];
            return state;
        case DELETE_SCHEDULE:
            let deletedIndex = state.findIndex(s => s._id === action.payload._id);
            if (deletedIndex > -1) state.splice(deletedIndex, 1);
            return state;
        default:
            return state;
    };
};

export default DeductionSchedules;